import { Button, Icon, Tooltip, useDisclosure } from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import FinishBasketModal from '@flows/src/components/flow-products/quotes/basket/FinishBasketModal';
import { useFlowsSession } from '@flows/src/api/getFlowsSessionById';
import { useParty } from '@parties/src/features/detail/api/getParty';

import useYellowhiveFlowProductsBasketStore from '@flows/src/store/zustand/flows-products/useYellowhiveFlowProductsBasketStore';
import { FinishBasketYellowHivePartyCreationModal } from '@flows/src/components/flow-products/quotes/basket/actions/yellowhive-party-creation-modal/FinishBasketYellowHivePartyCreationModal';
// import { recalculateYellowhiveSimulationBySessionId } from 'wg-api-sdk';

interface Props {
  sessionId: string;
}

const YellowhiveBasketFinishButton = ({ sessionId }: Props) => {
  const { t } = useTranslation();
  // sessionId is already provided via props
  const { data: sessionData } = useFlowsSession(sessionId);
  const partyId = sessionData?.prospect?.id || '';
  const { data: partyData, isSuccess: isPartyDataSuccess } = useParty(partyId);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const {
    isOpen: isPartyModalOpen,
    onClose: onPartyModalClose,
    onOpen: onPartyModalOpen,
  } = useDisclosure();

  const basketItems = useYellowhiveFlowProductsBasketStore(
    (state) => state.basketItems,
  );
  const isDisabled = basketItems.length === 0;

  const handlePartyCreationFinish = () => {
    onPartyModalClose();
    onOpen();
  };

  const getTooltipLabel = () => {
    if (isDisabled) {
      return t('FLOWS_PRODUCTS_BASKET_ACTIONS_VALIDATE_EMPTY_TOOLTIP');
    }
    return '';
  };

  const handleFinishWorkflow = () => {
    const isCompany = partyData?.type === 'COMPANY';
    if (isCompany) {
      onPartyModalOpen();
    } else {
      onOpen();
    }
  };

  return (
    <>
      {partyData && (
        <FinishBasketYellowHivePartyCreationModal
          isOpen={isPartyModalOpen}
          party={partyData}
          onClose={onPartyModalClose}
          onFinish={handlePartyCreationFinish}
          sessionId={sessionId}
        />
      )}
      <FinishBasketModal
        isOpen={isOpen}
        onClose={onClose}
        sessionId={sessionId}
      />
      <Tooltip isDisabled={!isDisabled} label={getTooltipLabel()}>
        <Button
          isDisabled={isDisabled && isPartyDataSuccess}
          onClick={handleFinishWorkflow}
          rightIcon={<Icon name="GeneralActionsArrowRight" />}
          flex={{ base: '1', tablet: 'initial' }}
        >
          {t('FINISH')}
        </Button>
      </Tooltip>
    </>
  );
};

export default YellowhiveBasketFinishButton;
